//@flow
import * as React from 'react';

import { MasterRider } from 'common/models/flow/MasterRider';
import { RiderId } from 'common/models/internal/RiderId';

import { translate } from 'react-i18next';
import debounce from 'lodash/debounce';
import { bulkRiderFetch as bulkRiderFetchApi } from 'common/middleware/api';

import EntityIdInput from 'common/entity/generic/EntityIdInput';
import type { Filter } from 'common/models/flow/Filter';

type Props = {
    disabled?: boolean,
    isLoading?: boolean,
    clientId: string,
    placeholder?: string,
    rider: ?MasterRider,
    theme?: Object,
    field: Object,
    autoFocus: boolean,
    getRiderFilters: (
        input: string,
        filterTeams: ?Array<string>,
        clientId: ?string
    ) => Object,
    onChange: (?RiderId, MasterRider) => void,
    t: (string, ?Object) => string,
    filterTeams?: Array<string>,
    hasError?: boolean,
    extraFilters: Array<Filter>,
    extendedRiderSearch?: boolean,
    selectedDate?: string
};

type State = {
    riders: Array<Object>
};

class RiderIdInput extends React.Component<Props, State> {
    static defaultProps = {
        extraFilters: []
    };

    constructor(props) {
        super(props);
        this.state = {
            riders: []
        };
        this.loadRiderOptions = debounce(this.loadRiderOptions, 200);
    }

    loadRiderOptions = (input: string, callback) => {
        const {
            clientId,
            getRiderFilters,
            filterTeams,
            extraFilters
        } = this.props;
        const filters = getRiderFilters(input, filterTeams, clientId);
        bulkRiderFetchApi
            .post(
                { clientId, include: 'RIDER_PERSONA,RIDER_STATUS' },
                { filters: [...filters, ...extraFilters] }
            )
            .then((response: Object) => {
                const { riders } = response;
                this.setState({ riders });
                callback(riders);
            })
            .catch(() => {
                //Ignore the error
            });
    };

    onChange = value => {
        const { onChange, clientId } = this.props;
        let riderId = null;
        if (value?.id) {
            riderId = RiderId.fromJS({
                clientId,
                riderId: value.id,
                version: value.version
            });
        }
        onChange && onChange(riderId, value);
    };

    render() {
        const { riders } = this.state;
        const { rider, field, t, autoFocus, ...rest } = this.props;
        const { placeholder } = field;
        return (
            <EntityIdInput
                {...rest}
                onChange={this.onChange}
                options={riders}
                value={rider}
                loadOptions={this.loadRiderOptions}
                placeholder={t(
                    placeholder || 'outletForm.fieldExecutiveSearchText'
                )}
                autoFocus={autoFocus}
            />
        );
    }
}

export default translate('entityManagement')(RiderIdInput);
